import { AxiosResponse } from 'axios';

import { InterviewReviewer } from '@/types/api/interview-reviewer';
import { supabase } from '@/lib/supabase';
import { asResponse } from '@/lib/supabase-helpers';
import { mapPartialProfile } from '@/lib/mappers';

type CreateInterviewReviewerParams = {
  personId: string;
};

export const getAllInterviewReviewers = async (): Promise<AxiosResponse<InterviewReviewer[]>> => {
  const { data, error } = await supabase
    .from('interview_reviewers')
    .select('*, profiles:profile_id(*)')
    .order('created_at', { ascending: false });

  if (error) throw error;

  const mapped = (data || []).map((row: any) => ({
    id: row.id,
    person: mapPartialProfile(row.profiles),
  }));

  return asResponse(mapped as unknown as InterviewReviewer[]);
};

export const createInterviewReviewer = async ({
  personId,
}: CreateInterviewReviewerParams): Promise<AxiosResponse<InterviewReviewer>> => {
  const { data, error } = await supabase
    .from('interview_reviewers')
    .insert({ profile_id: personId })
    .select('*, profiles:profile_id(*)')
    .single();

  if (error) throw error;

  return asResponse({
    id: data.id,
    person: mapPartialProfile(data.profiles),
  } as unknown as InterviewReviewer);
};

export const deleteInterviewReviewer = async ({
  interviewReviewerId,
}: {
  interviewReviewerId: string;
}): Promise<AxiosResponse<InterviewReviewer>> => {
  const { data, error } = await supabase
    .from('interview_reviewers')
    .delete()
    .eq('id', interviewReviewerId)
    .select()
    .single();

  if (error) throw error;
  return asResponse(data as unknown as InterviewReviewer);
};
